function isTablet() {
  return window.matchMedia('(max-width: 950px) and (min-width: 768px)').matches;
}
export default isTablet;
